import { render } from "./TabsPage.vue?vue&type=template&id=28f67faa"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\reimo\\Documents\\Projektide IT osa\\AccountaBuddy\\accounta-buddy-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__